import {html} from 'lit-html';
import {live} from 'lit-html/directives/live';
import {classMap} from 'lit-html/directives/class-map';
import {ifDefined} from 'lit-html/directives/if-defined';
import {DiscountType} from '../const';

/**
 * Render a discount code input
 * INFO: Discount.type = AUTO hides the full widget
 *
 * @returns {TemplateResult}
 */
const template = (discount, input, onApply, onRemove, onInput) => html`
    
    ${discount.type !== DiscountType.AUTO ? html`
    <div class="cl-po--discount">
        <div class="cl-po--discount-input">
            <input type="text" placeholder=${input.placeholder} class="${classMap({'cl-po--invalid': input.error })}" .value=${live(input.code)} @input=${(e) => onInput(e)} />
            <button @click=${(e) => onApply(e)}>
                ${input.loading ? html`<svg class="cl-po--icon loading" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0v2c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8h2z"></path></svg>`: input.button}
            </button>
        </div>
        ${input.error ? html` <p class="cl-po--discount-error">${input.error}</p>`: null}
       
        ${discount.valid ? html`
        <div class="cl-po--discount-wrap">
            <input type="hidden" name="discount" .value=${live(discount.code)} form=${ifDefined(input.cartFormLink)} />
            
            <div class="cl-po--discount-tag">
                <svg class="cl-po--icon tag" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path d="M17.78 3.09C17.45 2.443 16.778 2 16 2h-5.165c-.535 0-1.046.214-1.422.593l-6.82 6.89c0 .002 0 .003-.002.003-.245.253-.413.554-.5.874L.738 8.055c-.56-.953-.24-2.178.712-2.737L9.823.425C10.284.155 10.834.08 11.35.22l4.99 1.337c.755.203 1.293.814 1.44 1.533z" fill-opacity=".55"></path><path d="M10.835 2H16c1.105 0 2 .895 2 2v5.172c0 .53-.21 1.04-.586 1.414l-6.818 6.818c-.777.778-2.036.782-2.82.01l-5.166-5.1c-.786-.775-.794-2.04-.02-2.828.002 0 .003 0 .003-.002l6.82-6.89C9.79 2.214 10.3 2 10.835 2zM13.5 8c.828 0 1.5-.672 1.5-1.5S14.328 5 13.5 5 12 5.672 12 6.5 12.672 8 13.5 8z"></path></svg>
                <span>${discount.code}</span>
                <button @click=${(e) => onRemove(e)}>
                    <svg class="cl-po--icon remove" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 13"><path d="M1.5 1.5l10.05 10.05M11.5 1.5L1.45 11.55" stroke-width="2" fill="none" fill-rule="evenodd" stroke-linecap="round"></path></svg>
                </button>
            </div>
    
            ${input.success ? html` <p class="cl-po--discount-success">${input.success}</p>`: null}
        </div>
        `: null}
    </div>
    `: null}
`;


export default template;